import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryGrid from "../components/EntryGrid";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getformid, getcontroller, getsubkey, getWindowDimensions, setglobaldata, isZero,
    NumConv, DicVal, getglobaldata, DeepCopy, initializedata, RandomKey, Savestorage, Getstorage,
    PositiveValue, isEnabled, CellType
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entryformlock, entrytriggercall,readonly,reports } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));


export const RecieveS = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", ROW: "1", IMAGE: "pic",  FILE: "file", TOTAL:"T1" }
    const primarykeys = ["d_in_s_no", "d_in_s_row_no"];

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const entrylock = useSelector(state => state.form.entryformlock);
    const warndescription = useSelector(state => state.form.warndiscription);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefrow = useRef({ grid: undefined, column: undefined });
    const apiReftotal = useRef({ grid: undefined, column: undefined });
    const apirow = apiRefrow.current;
    const apitotal = apiReftotal.current;
    const AcceptNo = useRef({ type: '0', no:""});
    const locationstate = useRef(null);    //遷移State

    const entrydataRef = useRef(null);    //基本情報データ
    const rowsRef = useRef(null);         //入荷明細データ
    const colRef = useRef(null);          //入荷明細列情報  
    const totalRef = useRef(null);        //入荷合計データ
    const totalcolRef = useRef(null);   　//入荷合計列情報  
    const imageRef = useRef(null);        //画像
    const fileRef = useRef(null);         //ファイル  

    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const formlock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [rowDragManaged, setrowDragManaged] = useState(true);
    const [update, setUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const formid = getformid("RecieveS", props.location.search);
    const controller = getcontroller("RecieveS", props.location.search);
    const subkey = getsubkey(props.location.search);
    const CELLTYPE = CellType();
    const search = useLocation().search;
    const reportsRef = useRef(null);

    const actionurl = {
        "insert": "recieves/Insert",
        "update": "recieves/Update",
        "delete": "recieves/Delete",
        "saveas": "recieves/SaveAs",
        "storageadd": "recieves/AddStorage",
        "storagerowdel": "recieves/StorageRowdel",
        "upload": "recieves/Upload",
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "1", action: "INSERT" }
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }
    function statusKey(id) {
        return formid + "entry_" + id;
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    colRef.current = null;
                    totalcolRef.current = null;

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        if (isEmpty(entrydataRef.current)) return;
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_in_s_no"] = "";
            entrydataRef.current["d_in_s_createac"] = "";
            entrydataRef.current["d_in_s_createdate"] = "";
            entrydataRef.current["d_in_s_updateac"] = "";
            entrydataRef.current["d_in_s_update"] = "";
            //受入ロック解除
            for (let i = 0; i < rowsRef.current.length; i++) {
                rowsRef.current[i]["lockrow"] = false;
            }
            setrowDragManaged(true);    //行入れ替え可
            setsliplock(false);
            rerender();
        }
    }, [formstatus]);

    function setsliplock(value) {
        dispatch(entryformlock(value));
    }

    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
                entrydataRef.current["d_in_s_accepttype"] = locationstate.current.accepttype;
                entrydataRef.current["d_in_s_acceptno"] = locationstate.current.acceptno;
                AcceptAction(locationstate.current.acceptno, locationstate.current.accepttype, true);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function onFirstDataRendered(param, id) {
        if (id === G_id.ROW) {
            apiRefrow.current.grid = param.api;
            apiRefrow.current.column = param.columnApi;
        }
        if (id === G_id.TOTAL) {
            apiReftotal.current.grid = param.api;
            apiReftotal.current.column = param.columnApi;
            if (isEmpty(locationstate.current)) {
                RowDataChanged();
            } else {
                //遷移表示
                callshow();
            }
        }
    }

    function MenuQueryAction(action, param) {
        if (action === 'delete' && formstatus === "UPDATE") {
            if (param.tabvalue !== '0') {
                fnc.current.warnmsg("このシートのデータは削除できません");
                return false;
            }
        }
        return true;
    }
    function MenuAction(action, finallycallback,param) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") {
            clearform(true);
        }
        if (action === 'linkfield') {
            switch (finallycallback.table) {
                case "d_in_s":
                    let type = "100";
                    let col = textfields.find(e => e.columnid === finallycallback.field);
                    if (col !== undefined) {
                        type = col.type;
                        let key = finallycallback.field + "_" + type;
                        document.getElementById(key).focus();
                        document.getElementById(key).select();
                    }
                    Jump(G_id.BASE, type);
                    break;
                case "d_in_s_row":
                    Jump(G_id.ROW);
                    AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, apirow.grid);
                    break;
                default:
                    break;
            }
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('recieves/GetDataTree', { "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        if (code === "") {
            let col = textfields.find(e => e.columnid === "d_in_s_warehouse");
            if (!isEmpty(col)) col.locked = false;     //発送先有効
            col = textfields.find(e => e.columnid === "d_in_s_acceptno");
            if (!isEmpty(col)) col.locked = true;    //受入番号無効
            settextfields(textfields);
        }
        clearform(code==="");
        //データ読み込み
        LoadData(code);
        return true;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('recieves/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_in_s_memo" in row) data.data.d_in_s_memo = row.d_in_s_memo;
                                if ("d_in_s_sticky" in row) data.data.d_in_s_sticky = row.d_in_s_sticky;
                                if ("d_in_s_mytags" in row) data.data.d_in_s_mytags = row.d_in_s_mytags;
                            }
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            rowsRef.current = data.rowdata;
                            imageRef.current = data.images;
                            fileRef.current = data.files;
                            dispatch(setimagelist(data.images));
                            var totalfields = ["d_in_s_qty"];
                            var totalcols = columninfo.filter(e => e.logpid === "T1");
                            for (let i = 0; i < totalcols.length; i++) {
                                if (totalfields.indexOf(totalcols[i].columnid) === -1)
                                    totalfields.push(totalcols[i].columnid);
                            }
                            var total = { rowid: "TOTAL", grip: "計" };
                            for (let i = 0; i < totalfields.length; i++) {
                                total[totalfields[i]] = data.data[totalfields[i]];
                            }
                            totalRef.current = [total];
                            AcceptNo.current.type = data.data["d_in_s_accepttype"];
                            AcceptNo.current.no = data.data["d_in_s_acceptno"];

                            let newtextfields = DeepCopy(textfields);
                            let col = newtextfields.find(e => e.columnid === "d_in_s_warehouse");
                            if (!isEmpty(col)) col.locked = (AcceptNo.current.type === "2" || AcceptNo.current.type === "4");     //店舗配分時発送先編集不可
                            col = newtextfields.find(e => e.columnid === "d_in_s_acceptno");
                            if (!isEmpty(col)) {
                                col.locked = AcceptNo.current.type === "0";     //受入種別=なし時編集不可
                            }
                            settextfields(newtextfields);

                            //受入済の場合行入れ替え不可
                            let lock = data.rowdata.some(e => e.lockrow);
                            setrowDragManaged(!lock);
                            setsliplock(data.data["d_in_s_lock"] !== "0");   //伝票ロックか
                            rerender();
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }

    //リストValueChange
    function ListCellChange(params, columninfo, tabvalue) {
        //簡易計算処理
        var data = null;
        if (tabvalue !== "1") return data;
        if (params.colDef.field === "d_in_s_sliptype") {
            let sliptype = NumConv(params.newValue);
            if (sliptype === 1) {   //返品
                params.newValue = Math.abs(NumConv(DicVal(params.data, "d_in_s_row_qty", 0))) * -1;
                data = { d_in_s_row_qty: params.newValue }
            }
        }
        if (params.colDef.field === "d_in_s_row_qty") {
            let sliptype = NumConv(DicVal(params.data, "d_in_s_sliptype", 0));
            if (sliptype === 1) {   //返品
                params.newValue = Math.abs(NumConv(params.newValue)) * -1;
                data = { d_in_s_row_qty: params.newValue}
            }
        }
        return data;
    }

　  //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            if (params.colDef.field === "d_in_s_mytags" ||
                params.colDef.field === "d_in_s_sharetags" ||
                params.colDef.field === "d_in_s_sticky" ||
                params.colDef.field === "d_in_s_memo") {
                return false;
            }
        }
        if (!edit) return edit;
        if (status === "UPDATE") {
            if (DicVal(params.data, "d_in_s_lock", "") === "1") return false;    //伝票ロック
            if (params.colDef.field === "d_in_s_accepttype") return false;
            if (params.colDef.field === "d_in_s_row_accepttype" ||
                params.colDef.field === "d_in_s_row_acceptno" ||
                params.colDef.field === "d_in_s_row_acceptindex")
                return false;
            if (params.colDef.field === "d_in_s_row_code" ||
                params.colDef.field === "d_in_s_row_colno" ||
                params.colDef.field === "d_in_s_row_colnm" ||
                params.colDef.field === "d_in_s_row_size" ||
                params.colDef.field === "d_in_s_row_sizenm" ) {
                return false;   //編集不可　判定困難なため暫定
            }
        }
        return edit;
    }

    //明細カラム定義
    function ColdefSpecial(column) {
        if (column.field === "d_in_s_row_qty") {
            column.cellStyle = function (params) {
                if (!isAcceptRow(params.node.data)) return { backgroundColor: 'inherit' };
                if (NumConv(params.value) === 0) return { backgroundColor: 'inherit' };
                //受入元数＜入荷済数＋入荷数
                if (NumConv(params.node.data["originalqty"]) < NumConv(params.node.data["d_in_s_row_qty_sum"]) + NumConv(params.value))
                    return { backgroundColor: 'pink' };
                return { backgroundColor: 'inherit' };
            }
        }
        //受入時編集不可
        if (column.field === "d_in_s_row_code" ||
            column.field === "d_in_s_row_colno" ||
            column.field === "d_in_s_row_colnm" ||
            column.field === "d_in_s_row_size" ||
            column.field === "d_in_s_row_sizenm"    ) {
            column.editable = function (params) {
                if (params.context.entrylock) return false;
                if (isEnabled(params.node.data["lockrow"])) return false;
                return !isAcceptRow(params.node.data);
            }
            column.cellStyle = function (params) {
                if (!params.context.entrylock && (isEnabled(params.node.data["lockrow"]) || isAcceptRow(params.node.data))) {
                    return { backgroundColor: '#eee' };
                } else {
                    return null;
                }
            }
        }
   }
    function QuerySetColumn(coldef) {
        colRef.current = coldef;
        SetGridStyle(!isEmpty(AcceptNo.current.no));
        return colRef.current;
    }

    //受入データ行かどうか
    function isAcceptRow(data) {
        let value = DicVal(data, "d_in_s_row_acceptno", "0");
        return !isZero(value);
    }

    function Save(finallycallback) {
        storeRowData();
        if (AcceptNo.current.type !== "0" && isEmpty(AcceptNo.current.no)) {
            fnc.current.warnmsg("受入番号が入力されていません");
            return;
        }
        let row = rowsRef.current;
        if (!AGRef.current.ExistValidRow(rowsRef.current, columninfo, colRef.current)) {
            fnc.current.warnmsg("有効な入荷明細が存在しません");
            return;
        }
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        Apply();

        function Apply() {
            if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
            if (!isEmpty(totalRef.current)) {
                for (let key in totalRef.current[0]) {
                    if (key === "rowid") continue;
                    entrydataRef.current[key] = totalRef.current[0][key]
                }
            }
            const paramdata = {
                "controller": formid,
                "data": entrydataRef.current,
                "rowdata": row,
                "images": imageRef.current,
                "files": fileRef.current,
                "colinfo": columninfo,
                "code": edittingcode
            }
            fnc.current.postaxios(formstatus === "ENTRY FORM" ? "recieves/UpdateEntry" : "recieves/InsertEntry", paramdata,
                {
                    onSuccess: function (data) {
                        if (data.warning.length === 0) {
                            fnc.current.modify(false);
                            let code = data.request;
                            if (formstatus !== "ENTRY FORM") {
                                entrydataRef.current["d_in_s_no"] = data.request;
                                setedittingcode(data.request);
                                dispatch(changestatus("ENTRY FORM"));
                            }
                            if (newfiles.length !== 0) {        //v1.4
                                //新規ファイルアップロード
                                cfFileUpload("recieves", code, newfiles, fnc, () => LoadData(code));
                            } else {
                                fnc.current.success();
                                if (formstatus === "ENTRY FORM") {
                                    data.data['rowid'] = Getrowid();    //更新行キー
                                    finallycallback(data.data);
                                }
                                LoadData(code);     //再表示
                            }
                        }
                        else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                        fnc.current.wait(false);
                    },
                    errmsg: "登録に失敗しました"
                }
            )
        }
    }

   function Delete(finallycallback) {
       const param = {
           rowdata: [{ "rowid": edittingcode }],
           controller: controller
       }
        fnc.current.postaxios("recieves/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }

    //受入処理
    function AcceptAction(value, type, extarnal) {
        if (isEmpty(type)) type = AcceptNo.current.type;
        fnc.current.postaxios('recieves/GetAccept', { "code": value, "type": type, "colinfo": columninfo},
            {
                onSuccess: function (data) {
                    fnc.current.margeMaster(data.master);
                    AcceptNo.current.no = value;
                    AcceptNo.current.type = type;   //1:発注 2:発注店舗配分 3:出荷依頼 4:出荷依頼店舗配分
                    let cols = textfieldsall.filter(e => e.acceptfield.indexOf(AcceptNo.current.type + "=") !== -1)
                    for (let i = 0; i < cols.length; i++) {
                        let accfd = cols[i].columnid;
                        if (accfd in data.data)
                            entrydataRef.current[cols[i].columnid] = data.data[accfd];  //受入項目セット
                    }
                    
                    entrydataRef.current["d_in_s_accepttype"] = type;
                    if (AcceptNo.current.type === "2" || AcceptNo.current.type === "4") {
                        entrydataRef.current["d_in_s_warehouse"] = data.data["d_in_s_warehouse"];
                    }
                    entrydataRef.current["d_in_s_splr"] = data.data["d_in_s_splr"];
                    entrydataRef.current["d_in_s_acceptno"] = value;

                    let rowcols = columninfo.filter(e => e.acceptfield !== "" && e.logpid === G_id.ROW);
                    let rows = [];
                    for (let i = 0; i < data.rowdata.length; i++) {
                        let row = data.rowdata[i];
                        if (AcceptNo.current.type === "1" || AcceptNo.current.type === "3") {    //発注 or 出荷依頼
                            if ((AcceptNo.current.type === "1" ? row["d_order_s_row_infix"] : row["d_req_s_row_infix"]) === "1") {   //完了済
                                row["d_in_s_row_qty"] = 0;
                            } else {
                                //入荷数初期値＝元数－入荷済　※マイナス時0
                                let qty = NumConv(row["originalqty"]);
                                row["d_in_s_row_qty"] = PositiveValue(qty - NumConv(row["d_in_s_row_qty_sum"]));
                            }
                            //入荷計＝入荷済＋入荷数初期値
                            row["sumqty"] = NumConv(row["d_in_s_row_qty_sum"]) + NumConv(row["d_in_s_row_qty"]);
                            row["fix"] = "1";
                        } else {    //店舗配分
                            //配分数
                            row["allotqty"] = NumConv(row["allotqty"]);
                            //配分入荷済
                            row["d_in_s_row_shopqty_sum"] = NumConv(row["d_in_s_row_shopqty_sum"]);
                            if ((AcceptNo.current.type === "2" ? row["d_order_s_row_infix"] : row["d_req_s_row_infix"])=== "1") {
                                row["d_in_s_row_qty"] = 0;
                            } else {
                                //引取数初期値＝配分数－配分引取合計 ※マイナス時0
                                row["d_in_s_row_qty"] = PositiveValue(NumConv(row["allotqty"]) - NumConv(row["d_in_s_row_shopqty_sum"]));
                            }
                            //引取計＝引取済＋引取数初期値
                            row["sumqty"] = NumConv(row["d_in_s_row_qty_sum"]) + NumConv(row["d_in_s_row_qty"]);
                            row["fix"] = row["originalqty"] > row["sumqty"] ? "0" : "1";
                        }
                        for (let j = 0; j < rowcols.length; j++) {
                            if (rowcols[j].acceptfield in data.row) {
                                if (rowcols[j].columnid in row) continue;   //既定セット済
                                entrydataRef.current[rowcols[j].columnid] = data.row[rowcols[j].acceptfield];
                            }
                        }
                        rows.push(row);
                    }
                    rowsRef.current = rows;
                    SetGridStyle(true);
                    if (isEnabled(extarnal)) { //外部起動
                        let newfields = DeepCopy(textfields);
                        let col = newfields.find(e => e.columnid === "d_in_s_warehouse");
                        col.locked = (type === "2" || type ==="4");     //発注配分または出荷依頼配分時発送先編集不可
                        col = newfields.find(e => e.columnid === "d_in_s_acceptno");
                        col.locked = type === "0";     //受入種別=なし時編集不可
                        settextfields(newfields);
                    }
                    fnc.current.closewarnning();
                    rerender();
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    //受入番号を元に戻す
                    entrydataRef.current["d_in_s_acceptno"] = AcceptNo.current.no;
                    fnc.current.entryrerender();
                    fnc.current.warnmsg("入力された受入番号は存在しません");
                    fnc.current.wait(false);
                },
                errmsg: "処理に失敗しました"
            }
        )
    }
    //明細カラム設定
    function SetGridStyle(isAccept) {
        if (isEmpty(colRef.current)) return;
        let target = ["originalqty", "sumqty", "fix", "d_in_s_row_acceptindex", "allotqty", "d_in_s_row_shopqty_sum"]
        if (!isAccept) {
            if (!colRef.current.some(e => e.field === target[0])) return false;
            //追加項目を除去
            let newcol = colRef.current.filter(e => target.indexOf(e.field) === -1)
            colRef.current = newcol;
            return;
        } 
        let addcols = (AcceptNo.current.type === "1" || AcceptNo.current.type === "3") ?
            [
                { id: "originalqty", name: AcceptNo.current.type === "1"?"発注数":"依頼数", type: CELLTYPE.NUM, format: '', width:80 },
                { id: "sumqty", name: "入荷計", type: CELLTYPE.NUM, format: '', width: 80 },
                { id: "fix", name: "完了", type: CELLTYPE.CHECK, format: '', width: 50 },
                { id: "d_in_s_row_acceptindex", name: "RNo", type: CELLTYPE.NUM, format: 'showzero', width: 50 },
            ] :
            [
                { id: "allotqty", name: "配分数", type: CELLTYPE.NUM, format: '', width: 80 },
                { id: "d_in_s_row_shopqty_sum", name: "済数", type: CELLTYPE.NUM, format: '', width: 80 },
                { id: "originalqty", name: AcceptNo.current.type === "1" ?"発注数":"依頼数", type: CELLTYPE.NUM, format: '', width: 80 },
                { id: "sumqty", name: "入荷計", type: CELLTYPE.NUM, format: '', width: 80 },
                { id: "fix", name: "完了", type: CELLTYPE.CHECK, format: '', width: 50 },
                { id: "d_in_s_row_acceptindex", name: "RNo", type: CELLTYPE.NUM, format: 'showzero', width: 50 },
            ];

        //再作成が必要かの判定
        if (colRef.current.some(e => e.field === target[0])) {
            if ((AcceptNo.current.type === "1" || AcceptNo.current.type === "3") && !colRef.current.some(e => e.field === "allotqty")) return false;
            if ((AcceptNo.current.type === "2" || AcceptNo.current.type === "4") && colRef.current.some(e => e.field === "allotqty")) return false;
       }

        let columns = [];
        for (let i = 0; i < addcols.length; i++) {
            let column =
            {
                headerName: addcols[i].name,
                field: addcols[i].id,
                colId: addcols[i].id,
                width: addcols[i].width,
                editable: false,
                pinned: 'right',
                colinfo: addcols[i].type === CELLTYPE.CHECK ? { datatype: CELLTYPE.CHECK } : { datatype: CELLTYPE.NUM, decimalplace: 0, format: addcols[i].format }
            }
            if (addcols[i].type === CELLTYPE.CHECK) {  //完了
                column.editable = function (params) {
                    return isAcceptRow(params.node.data);
                }
            }
            AGRef.current.SetColDefTypeInfo(addcols[i].type, column);
            columns.push(column);
        }
        colRef.current = [...colRef.current, ...columns];
    }

    function QuerySearchClick(def, cancel) {
        if (def.columnid === "d_in_s_acceptno") {
            let newdef = DeepCopy(def);
            if (AcceptNo.current.type === "1") {    //発注
                newdef.dataid = "d_order_s:in";
            }
            if (AcceptNo.current.type === "2") {    //発注店舗配分
                newdef.dataid = "d_order_s_allot";
            }
            if (AcceptNo.current.type === "3") {    //出荷依頼
                newdef.dataid = "d_req_s:in";
            }
            if (AcceptNo.current.type === "4") {    //出荷依頼店舗配分
                newdef.dataid = "d_req_s_allot:in";
            }
            return newdef;
        }
        return null;
    }

    function QueryInsertRow(row) {
        if (formstatus === "ENTRY FORM") {
            //指定行が受け入れ済の場合エラー
            if (isEnabled(row.data.lockrow)) {
                fnc.current.warnmsg("この明細は受入済の為行挿入できません");
                return false;
            }
            //指定行以降に受け入れ済が存在する場合エラー
            for (let i = row.rowIndex + 1; i < rowsRef.current.length; i++) {
                if (isEnabled(rowsRef.current[i]["lockrow"])) {
                    fnc.current.warnmsg("受入済明細が存在する為行挿入できません");
                    return false;
                }
            }
        }
        return true;
    }
    //行削除前イベント
    function QueryRemoveRow(rows) {
        if (formstatus === "ENTRY FORM") {
            for (let i = 0; i < rows.length; i++) {
                if (isEnabled(rows[i].lockrow)) {
                    if (rows.length === 1) fnc.current.warnmsg("この明細は受入済の為行削除できません");
                    else fnc.current.warnmsg("受入済の明細が含まれている為行削除できません");
                    return false;
                }
            }
        }
        return true;
    }

    //Basic Data Change
    function ValueChanged(id, value) {
        if (id === "d_in_s_accepttype") {   //受入種別
            if (value === AcceptNo.current.type) return;
            if (isEmpty(value)) value = "0";
            if (value !== "0" && value !== "1" && value !== "2" && value !== "3" && value !== "4") return;
            if (value === AcceptNo.current.type) return;
            AcceptNo.current = { type: value, no: "" };
            entrydataRef.current["d_in_s_acceptno"] = "";
            rowsRef.current = null;
            SetGridStyle(false);
            totalRef.current = [{ rowid: "TOTAL", grip: "計" }];
            if (textfields.length !== 0) {
                let newfields = DeepCopy(textfields);
                let col = newfields.find(e => e.columnid === "d_in_s_warehouse");
                col.locked = (value === "2" || value ==="4");     //配分時発送先編集不可
                col = newfields.find(e => e.columnid === "d_in_s_acceptno");
                col.locked = value === "0";     //受入種別=なし時編集不可
                settextfields(newfields);
            }
            rerender();
            return;
        }
        if (id === "d_in_s_acceptno") {
            if (value === AcceptNo.current.no) return;
            if (isEmpty(value)) {
                AcceptNo.current.no = "";
                entrydataRef.current["d_in_s_acceptno"] = "";
                rowsRef.current = null;
                SetGridStyle(false);
                totalRef.current = [{ rowid: "TOTAL", grip: "計" }];
                rerender();
                return;
            }
            AcceptAction(value);
        }
        if (id === "d_in_s_sliptype") {
            if (value === "1") {   //返品
                for (let i = 0; i < rowsRef.current.length; i++) {
                    rowsRef.current[i]["d_in_s_row_qty"] = -1 * Math.abs(NumConv(rowsRef.current[i]["d_in_s_row_qty"]));
                    let node = apiRefrow.current.grid.getDisplayedRowAtIndex(i);
                    if (!isEmpty(node)) node.setData(rowsRef.current[i]);
                    if (isAcceptRow(rowsRef.current[i])) {
                        //入荷計＝入荷数＋入荷済
                        let total = NumConv(rowsRef.current[i]["d_in_s_row_qty"]) + NumConv(rowsRef.current[i]["d_in_s_row_qty_sum"]);
                        node.setDataValue("sumqty", total);
                        if ((AcceptNo.current.type === "1" ? rowsRef.current[i]["d_order_s_row_infix"] : rowsRef.current[i]["d_req_s_row_infix"]) !== "1") {    //完了登録済以外
                            node.setDataValue("fix", NumConv(rowsRef.current[i]["originalqty"]) > NumConv(rowsRef.current[i]["sumqty"]) ? "0" : "1");
                        }
                    }
                }
                RowDataChanged();   //再計算
            }
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }
    //Grid Data Change
    function ChangeRowValue(params) {
        let rowidx = params.node.rowIndex;
        if (params.column.colId === "d_in_s_row_code" ) {
            //C/#クリア
            rowsRef.current[rowidx]["d_in_s_row_colno"] = "";
            rowsRef.current[rowidx]["d_in_s_row_colnm"] = "";
            rowsRef.current[rowidx]["d_in_s_row_size"] = "";
            rowsRef.current[rowidx]["d_in_s_row_sizenm"] = "";
            let node = apiRefrow.current.grid.getDisplayedRowAtIndex(rowidx);
            if (!isEmpty(node)) {
                node.setData(rowsRef.current[rowidx]);
            }
        }
        if (params.column.colId === "d_in_s_row_qty" || params.column.colId === "d_in_s_row_price") {
            if (params.column.colId === "d_in_s_row_qty") {
                let sliptype = DicVal(entrydataRef.current, "d_in_s_sliptype", "");
                if (sliptype === "1") {   //返品
                    rowsRef.current[rowidx]["d_in_s_row_qty"] = -1 * Math.abs(NumConv(params.node.data["d_in_s_row_qty"]));
                    let node = apiRefrow.current.grid.getDisplayedRowAtIndex(rowidx);
                    if (!isEmpty(node))  node.setData(rowsRef.current[rowidx]);
                }
            }
            if (isAcceptRow(params.node.data) && params.column.colId === "d_in_s_row_qty") {
                if (isEmpty(apiRefrow.current.grid)) return;
                if (isEmpty(rowsRef.current)) return;
                //入荷計＝入荷数＋入荷済
                let total = NumConv(params.node.data["d_in_s_row_qty"]) + NumConv(params.node.data["d_in_s_row_qty_sum"]);
                var node = apiRefrow.current.grid.getRowNode(params.node.data["rowid"]);
                if (!isEmpty(node)) {
                    node.setDataValue("sumqty", total);
                    if ((AcceptNo.current.type === "1" ? params.node.data["d_order_s_row_infix"] : params.node.data["d_req_s_row_infix"]) !== "1") {    //完了登録済以外
                        node.setDataValue("fix", NumConv(params.node.data["originalqty"]) > NumConv(params.node.data["sumqty"]) ? "0" : "1");
                    }
                }
            }
            RowDataChanged();
        }
        storeRowData(G_id.Row);
    }

    function RowValueChanged(colid, targets) {
        if (colid === "d_in_s_row_code") {
            for (let i = 0; i < targets.length; i++) {
                //C/#クリア
                targets[i]["d_in_s_row_colno"] = "";
                targets[i]["d_in_s_row_colnm"] = "";
                targets[i]["d_in_s_row_size"] = "";
                targets[i]["d_in_s_row_sizenm"] = "";
                var node = apiRefrow.current.grid.getRowNode(targets[i].rowid);
                if (!isEmpty(node)) {
                    node.setData(targets[i]);
                }
            }
        }
        RowDataChanged();
    }
    //Grid Row Data Change
    function RowDataChanged() {
        if (isEmpty(apiRefrow.current.grid)) return;
        if (isEmpty(rowsRef.current)) rowsRef.current = [];
        if (EmptyPanel(G_id.TOTAL)) return;
        let total = 0;
        for (let i = 0; i < rowsRef.current.length; i++) {
            total += NumConv(rowsRef.current[i]["d_in_s_row_qty"]);
        }
        totalRef.current[0]["d_in_s_qty"] = total;
        let rowNode = apitotal.grid.getRowNode("TOTAL");
        if(!isEmpty(rowNode)) rowNode.setData(totalRef.current[0]);
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined || panel === G_id.ROW) {
            rowsRef.current = AGRef.current.GetDatasource(apirow.grid);
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.ROW) panelid = 'rowGrid';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //入力フィールドクリア
    function clearform(newform) {
        setsliplock(false);
        entrydataRef.current = initializedata(textfieldsall, staff);
        rowsRef.current = [{ rowid: RandomKey() }];
        totalRef.current = [{ rowid: "TOTAL", grip: "計" }];
        dispatch(setimagelist([]));
        imageRef.current = null;
        fileRef.current = null;
        AcceptNo.current = {type:"0", no:""};
        fnc.current.modify(false);
        //列情報初期化
        colRef.current = null;
        totalcolRef.current = null;

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        AGRef.current.SaveColState(statusKey(G_id.ROW), EmptyPanel(G_id.ROW) ? null : apirow.column);
        AGRef.current.SaveColState(statusKey(G_id.TOTAL), EmptyPanel(G_id.TOTAL) ? null : apitotal.column);
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    function EmptyPanel(id, type) {
        try {
            let tbltype = tabletype(id);
            return isEmpty(columns.find(e => e.type === tbltype));
        } catch { return false; }
    }
    //パネル別列情報取得
    function tabletype(id) {
        if (id.substr(0, 1) === "T") {  //Total
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type: fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.ROW:
                    cols = AGRef.current.GetshownColDef(apirow.column);
                    break;
                default:
                    continue;
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        //Total Grid
        cols = AGRef.current.GetshownColDef(apitotal.column);
        for (let i = 0; i < cols.length; i++) {
            let col = DeepCopy(cols[i]);
            col.type = tabletype(G_id.TOTAL);
            coldef.push(col);
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    var type = tabletype(G_id.ROW);
                    var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    colRef.current = coldef;
                    type = tabletype(G_id.TOTAL);
                    coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    totalcolRef.current = coldef;
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }
    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }
    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock} />
                ))}
            </ul>
        );
    });
    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.ROW) {
            return (
                <React.Fragment>
                    <EntryGrid
                        id={props.panel.id}
                        elemid="rowGrid"
                        entrydataRef={entrydataRef}
                        dataRef={rowsRef}
                        columnRef={colRef}
                        columninfo={columninfo}
                        columns={columns}
                        type={tabletype(G_id.ROW)}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        statusKey={formid + "entry_" + G_id.ROW}
                        ValueChanged={ChangeRowValue}
                        RowValueChanged={RowValueChanged}
                        RemoveRow={RowDataChanged}
                        ColdefSpecial={ColdefSpecial}
                        QuerySetColumn={QuerySetColumn}
                        rowDragManaged={rowDragManaged}
                        QueryRemoveRow={QueryRemoveRow}
                        QueryInsertRow={QueryInsertRow}
                    />
                    {EmptyPanel(G_id.TOTAL) ? null :
                        <EntryGrid
                            id={"T" + props.panel.id}
                            elemid="totalGrid"
                            dataRef={totalRef}
                            columnRef={totalcolRef}
                            columninfo={columninfo}
                            columns={columns}
                            type={tabletype(G_id.TOTAL)}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            statusKey={formid + "entry_" + G_id.TOTAL}
                            total={true}
                        />
                    }
                </React.Fragment>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        return null;

    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name === '' ? <div style={{ display: 'inline-block', height: 10 }}></div> : p.name}
                                    {p.name2 !== '' ? '-' : ''}
                                    <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_in_s'}
                primarykey={primarykeys}
                parentedit={true}
                navmenu={formlock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                listcellchange={ListCellChange}
                slipsave={true}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.2,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};
